import {Directive, OnDestroy} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {Sort} from "@angular/material/sort";

@Directive()
export abstract class ListPage implements OnDestroy {

  protected readonly currentPage$ = new BehaviorSubject(1);
  protected readonly pageSize$ = new BehaviorSubject(10);
  protected readonly search$ = new BehaviorSubject('');
  protected readonly sort$ = new BehaviorSubject<Sort>({active: 'createdAt', direction: 'desc'});
  protected readonly refresh$ = new Subject<void>();

  protected readonly maxSize: number = 5;
  protected readonly responsive: boolean = true;

  protected pageChanged($event: number) {
    this.scrollToTop();
    this.currentPage$.next($event)
  }

  protected onSearch(value: string) {
    this.currentPage$.next(1);
    this.search$.next(value);
  }

  protected refreshData() {
    this.refresh$.next();
  }

  protected onSortData(sort: Sort) {
    if (sort.direction === '') {
      sort.direction = 'asc';
    }
    this.sort$.next(sort);
  }

  public ngOnDestroy(): void {
    this.currentPage$.complete();
    this.pageSize$.complete();
    this.search$.complete();
    this.refresh$.complete();
    this.sort$.complete();
  }

  private scrollToTop() {
    setTimeout(() => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }, 0);
  }
}
